// extracted by mini-css-extract-plugin
export var arrowUpAndDown = "VideoCard-module--arrow-up-and-down--32f4a";
export var link = "VideoCard-module--link--ff52f";
export var textContainer = "VideoCard-module--textContainer--1da6e";
export var videoCardContainer = "VideoCard-module--videoCardContainer--51bf0";
export var videoContainer = "VideoCard-module--videoContainer--6ebcf";